import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import Modal from '../../../../incase-domain/components/modals/directory/Modal';

interface ChatbotProps {
    header: string;
    profile: string;
    therapy: string;
    diagnosis: string;
}

interface ChatbotModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: (chatbotProps: ChatbotProps) => void;
}

function ChatbotModal({isOpen, onClose, onConfirm}: ChatbotModalProps): JSX.Element {
    const {t} = useTranslation();

    const [chatbotProps, setChatbotProps] = useState<ChatbotProps>({header: '', profile: '', therapy: '', diagnosis: ''});

    const isValid =
        chatbotProps.header.trim() && chatbotProps.profile.trim() && chatbotProps.therapy.trim() && chatbotProps.diagnosis.trim();

    const handleConfirm = (): void => {
        if (!isValid) return;

        const trimmedProps = {
            header: chatbotProps.header.trim(),
            profile: chatbotProps.profile.trim(),
            therapy: chatbotProps.therapy.trim(),
            diagnosis: chatbotProps.diagnosis.trim(),
        };
        onConfirm(trimmedProps);
        setChatbotProps({header: '', profile: '', therapy: '', diagnosis: ''});
        onClose();
    };

    return (
        <Modal
            isOpen={isOpen}
            onCancel={onClose}
            header={t('presEditPage.editSidebar.elements.chatbot.chatbot')}
            description={t('presEditPage.editSidebar.elements.chatbot.modalDescription')}
            icon="solar:calculator-bold"
            showCancel
            cancelText={t('common.dismiss')}
            showConfirm
            confirmText={t('common.add')}
            onConfirm={handleConfirm}
            confirmDisabled={!isValid}
            size="lg"
        >
            <div className="l-group--form u-mt-1">
                <div className={`l-group__item `}>
                    <label className="c-label">{t('presEditPage.editSidebar.elements.chatbot.header')}</label>
                    <div className="c-sidepanel__input">
                        <input
                            type="text"
                            className="c-sidepanel__input_field"
                            placeholder={t('presEditPage.editSidebar.elements.chatbot.headerPlaceholder')}
                            value={chatbotProps.header}
                            onChange={(e) => setChatbotProps({...chatbotProps, header: e.target.value})}
                        />
                    </div>
                </div>

                <div className="l-group__item">
                    <label className="c-label">{t('presEditPage.editSidebar.elements.chatbot.profile')}</label>
                    <div className="c-sidepanel__input">
                        <textarea
                            rows={4}
                            className="c-sidepanel__input_field"
                            placeholder={t('presEditPage.editSidebar.elements.chatbot.profilePlaceholder')}
                            value={chatbotProps.profile}
                            onChange={(e) => setChatbotProps({...chatbotProps, profile: e.target.value})}
                        />
                    </div>
                </div>

                <div className={`l-group__item `}>
                    <label className="c-label">{t('presEditPage.editSidebar.elements.chatbot.therapy')}</label>
                    <div className="c-sidepanel__input">
                        <textarea
                            rows={4}
                            className="c-sidepanel__input_field"
                            placeholder={t('presEditPage.editSidebar.elements.chatbot.therapyPlaceholder')}
                            value={chatbotProps.therapy}
                            onChange={(e) => setChatbotProps({...chatbotProps, therapy: e.target.value})}
                        />
                    </div>
                </div>

                <div className={`l-group__item `}>
                    <label className="c-label">{t('presEditPage.editSidebar.elements.chatbot.diagnosis')}</label>
                    <div className="c-sidepanel__input">
                        <textarea
                            rows={4}
                            className="c-sidepanel__input_field"
                            placeholder={t('presEditPage.editSidebar.elements.chatbot.diagnosisPlaceholder')}
                            value={chatbotProps.diagnosis}
                            onChange={(e) => setChatbotProps({...chatbotProps, diagnosis: e.target.value})}
                        />
                    </div>
                </div>
            </div>
        </Modal>
    );
}

export default ChatbotModal;
